import { Card, Table } from '../ui';

const ORG_SIZES = {
  small:      'Small (1–50)',
  medium:     'Medium (51–250)',
  large:      'Large (251–1,000)',
  enterprise: 'Enterprise (1,000+)',
};

const STATUS_LABELS = {
  active:    { label: 'Active',    cls: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' },
  completed: { label: 'Completed', cls: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400' },
  paused:    { label: 'Paused',    cls: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400' },
};

export default function ClientProfile({ client }) {
  const status = STATUS_LABELS[client.consultingStatus] || STATUS_LABELS.active;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Company info */}
      <Card className="p-5">
        <h3 className="font-semibold text-text-primary-light dark:text-text-primary mb-4">Company Information</h3>
        <dl className="space-y-3">
          <div>
            <dt className="text-xs font-medium text-text-muted-light dark:text-text-muted uppercase tracking-wide">Name</dt>
            <dd className="text-sm text-text-primary-light dark:text-text-primary mt-0.5">{client.name}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-text-muted-light dark:text-text-muted uppercase tracking-wide">Industry</dt>
            <dd className="text-sm text-text-primary-light dark:text-text-primary mt-0.5">{client.industry || '—'}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-text-muted-light dark:text-text-muted uppercase tracking-wide">Organisation Size</dt>
            <dd className="text-sm text-text-primary-light dark:text-text-primary mt-0.5">
              {ORG_SIZES[client.organisationSize] || '—'}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-text-muted-light dark:text-text-muted uppercase tracking-wide">Engagement Status</dt>
            <dd className="mt-0.5">
              <span className={`text-[11px] px-1.5 py-0 rounded font-medium ${status.cls}`}>
                {status.label}
              </span>
            </dd>
          </div>
          <div>
            <dt className="text-xs font-medium text-text-muted-light dark:text-text-muted uppercase tracking-wide">Location</dt>
            <dd className="text-sm text-text-primary-light dark:text-text-primary mt-0.5">
              {[client.village, client.region].filter(Boolean).join(', ') || '—'}
            </dd>
          </div>
        </dl>
      </Card>

      {/* Contacts */}
      <Card padding="none">
        <div className="p-5 pb-2">
          <h3 className="font-semibold text-text-primary-light dark:text-text-primary">Key Contacts</h3>
        </div>
        {client.contacts?.filter(c => c.name).length ? (
          <Table
            cellPadding="compact"
            headers={[
              { label: 'Name' },
              { label: 'Role' },
              { label: 'Email' },
            ]}
            rows={client.contacts.filter(c => c.name).map((c) => ({
              cells: [
                { content: c.name, className: 'text-text-primary-light dark:text-text-primary' },
                { content: c.role, className: 'text-text-secondary-light dark:text-text-secondary' },
                { content: c.email, className: 'text-text-secondary-light dark:text-text-secondary' },
              ],
            }))}
          />
        ) : (
          <p className="text-sm text-text-muted-light dark:text-text-muted p-5 pt-2">No contacts added.</p>
        )}
      </Card>
    </div>
  );
}
